export const EditorsType = {
    JODIT:"جودیت ساده",
    WYSIWYG:"ویسیویگ ",
}
